import { Text, TextProps, useColorMode } from '@chakra-ui/react'
import { DataType } from 'ka-table'
import { startCase } from 'lodash'
import { ReactNode } from 'react'
import InputContainer from './InputContainer'

export interface Props {
  name?: string
  value: any
  dataType?: DataType
  formatReadOnlyValue?: (props: Props) => ReactNode
  textProps?: TextProps
}

export default function ReadOnlyProperty({
  name,
  value,
  dataType,
  formatReadOnlyValue,
  textProps,
}: Props) {
  const { colorMode } = useColorMode()
  if (!value) return null

  return (
    <InputContainer gap={1} label={startCase(name)}>
      <Text
        textStyle="bodySmall"
        fontWeight="normal"
        background={colorMode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.1)'}
        borderRadius="10px"
        p={2}
        {...textProps}
      >
        {formatReadOnlyValue ? formatReadOnlyValue({ name, value, dataType }) : value}
      </Text>
    </InputContainer>
  )
}
